import LoginForm from "src/components/Login/loginForm";
import { redirect } from "react-router-dom";
import { Box } from "@mui/material";
import data from "src/permissions.json";

const LoginPage = () => {

  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, rgba(100,0,113,1) 39%, rgba(0,35,96,1) 100%)",
      }}
      height={"100vh"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <LoginForm
        //without this props i can't specify an image
        isImageForm={true}
        imageForm={require("src/img/logo.png")}
      />
    </Box>
  );
};

export default LoginPage;

export async function action({ request }) {
  const baseUrl=process.env.REACT_APP_API_ENDPOINT
  // const permissions = permissionsJson
  const permissions = data;
  const formData = await request.formData();
  const body = {
    userName: formData.get("username"),
    password: formData.get("password"),
  };
  localStorage.setItem("userName",body.userName)

  const response = await fetch(`${baseUrl}/authenticate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (response.status === 422 || response.status === 401) {
    return {
      error: "Unauthorized",
      message: "Username o password non validi",
    };
  } 

  if (!response.ok) {
    return;
  } 
  const resData = await response.json();
  const token = resData.jwtToken;
  var roles = [];
  resData.roleName.forEach(r =>  roles.push(
  permissions.Policy.roles.find((role) =>
  role.identityRoles.includes(r)
  ).name))
  localStorage.setItem("token", token);
  let rolesString = JSON.stringify(roles);

  localStorage.setItem("roles",rolesString)
  console.log("Access granted");

  const expiration = new Date();
  expiration.setHours(expiration.getHours() + 3);
  localStorage.setItem("expiration", expiration.toISOString());

  return redirect("/dashboard");
}
